export const departments = {
  LIST: {
    TITLE: "Departments",
    NAME: "Name",
    ABBREVIATION: "Abbreviation",
    IS_ACCESSIBLE_ONLY_FOR_DEPARTMENT_USERS: "Is accessible only for department users",
    STATUS: "Status",
  },
  DETAILS: {
    ADD_TITLE: "Add department",
    DETAILS_TITLE: "Department details",
    NAME: "Name",
    ABBREVIATION: "Abbreviation",
    IS_ACCESSIBLE_ONLY_FOR_DEPARTMENT_USERS: "Is accessible only for department users",
    STATUS: "Status",
    ACTIONS: "Actions",
  }
}
